import API from "../../API/api";

export const fetchingAll = async ( messageData) => {
  try {
    const response = await API.get(
      `/announcements`,
      messageData
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const MakeAnnouncement = async ( messageData) => {
  try {
    const response = await API.post(
      `/announcements`,
      messageData
    );
    return response.data;
  } catch (err) {
    console.error("Error :", err);
    throw err;
  }
};